import { render } from "./ContentWithPills.vue?vue&type=template&id=19629cec"
import script from "./ContentWithPills.vue?vue&type=script&lang=js"
export * from "./ContentWithPills.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__